var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryStyleThumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12.5,
    width: 30,
    height: 12,
    rx: 1,
    fill: "#0E7490"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#0E7490"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#0E7490"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 27.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#0E7490"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 47,
    rx: 1.5,
    stroke: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryStyleThumbnail);
export default __webpack_public_path__ + "static/media/gallery-style-thumbnail.42a5030c9cee6ea73c9366941dc14b76.svg";
export { ForwardRef as ReactComponent };